import React, {useState} from "react";
import { motion, AnimatePresence } from "framer-motion";
import Section from "./Section";

import 'assets/css/Faq.min.css';

const FaqItem = ({title, description}) => {

    const [open, setOpen] = useState(false);

    const titleVariants = {
        open : {
            marginBottom : 0,
            transition:{
                duration: 0.3,
            },
        },
        close : {
            marginBottom : 15,
            transition:{
                duration: 0.3,
            },
        },
    }

    const descriptionVariants = {
        open : {
            maxHeight: 10000,
            scaleY : 1,
            marginBottom : 15,
            opacity : 1,
            originY : "top",
            transition:{
                duration: 0.3,
            },
        },
        close : {
            maxHeight: 0,
            scaleY : 0,
            marginBottom : 0,
            opacity:0,
            originY : "top",
            transition:{
                duration: 0.3,
            },
        },
    }

    return (
        <>
        <motion.div variants={ titleVariants } animate={ open ? "open" : "close" } initial="close" className={`col-12 faq-item${  open ? " open" : "" }`} onClick={ () => setOpen(!open) }>
            <div className="title">{title}</div>
            <div className="sign"><i className={ open ? "fas fa-minus" : "fas fa-plus" }></i></div>
        </motion.div>

        <AnimatePresence>
            { open && (
                <motion.div variants={ descriptionVariants } animate={ open ? "open" : "close" } exit="close" initial="close" className={`col-12 faq-item-description${  open ? " open" : "" }`}>{description}</motion.div>
            )}
        </AnimatePresence>
        </>
    );
}

const Faq = ({data, sectionAdditionalClasses}) => {

    //Ha nincs megadva a data prop, akkor az alapértelmezett kérdés-válaszok kerülnek felhasználásra
    if( typeof data === "undefined" ) {
        data =[
            {
                title : "Mikor lesz az átadás?",
                description : "Várhatóan 2023.09.01."
            }, 
            {
                title : "Milyen részletekben lehet fizetni, milyen a fizetési ütemezés?",
                description : "..."
            }, 
            {
                //2024.06.06 - Ugyan MZoli "megnézte" és "nem találta", de benne volt, hogy az eladót terhelik az ügyvédi költségek.
                //Mostantól a vásárlót terhelik ezek a költségek.
                title : "Ki fizeti az ügyvédi díjat?",
                description : "A vevő"
            },
            {
                title : "Elő -, vagy végszerződés készül? ",
                description : "Előszerződés, majd a birtokba adás előtt végszerződés"
            }, 
            {
                title : "A burkolatokat ki tudom választani? ",
                description : "Igen (Duravit D-CODE szaniterek, GROHE csaptelepek, Olasz I. osztályú hidegburkolatok/kerámiák, Egger laminált parketta 6 féle színben, Jaffholz ajtók 6 féle színben)"
            }, 
            {
                title : "Hozhatok én is burkolatot?",
                description : "Nem"
            }, 
            {
                title : "Szerkezetkész állapotban megvásárolhatom a lakást? ",
                description : "Igen"
            }, 
            {
                title : "A konyhabútor is benne van a vételárban? ",
                description : "Nincs"
            }, 
        ]
    }

    return (
        <Section additionalClasses={ sectionAdditionalClasses && sectionAdditionalClasses } title="GYIK" description="Gyakran ismételt kérdések">
            <div className="row faq-row">
                {
                    data.map(function(curr, index){
                        return <FaqItem title={ curr.title } description={ curr.description } key={`faq-item-${index}`}/>
                    })
                }
            </div>
        </Section>
    )
}

export default Faq;